import React, { useState, useEffect, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getNestedProperty } from '../../helpers/getNestedProperty';
import { StatusInputWrapper } from '../StatusInputWrapper';

// address autofill is only used for Home Address input fields and not for mailing address fields
const AddressAutofill = ({ t, label, reduxAppProperty, changeObjectPropertyAction, validateStreetAddress, streetAddressError, streetAddressValid, setIsError, validateCity, cityError, cityValid, validatePostalCode, postalCodeError, postalCodeValid, validateApartment, apartmentError, apartmentValid }) => {
    // const dispatch = useDispatch()
    const [isFocussed, SetIsFocussed] = useState(false)

    const streetAddress = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).streetAddress)

    // const [str, setStr] = useState(streetAddress)

    const [dataArr, setDataArr] = useState([])

    //turns dropdown on and off
    const [display, setDisplay] = useState(false)

    const [streetname, setStreetname] = useState([])

    const [streetNameFull, setStreetNameFull] = useState([])

    const [cityName, setCityName] = useState([])

    const [civNumId, setCivNumId] = useState([])


    const handleStreetAddress = (e) => {
        try {

            // setDisplay(true)
            let name = e.currentTarget.value
            if (name != '') {
                setDisplay(true)
            }
            else {
                setDisplay(false)
            }
            const tempSt = []
            const tempStFull = []
            const tempCity = []
            const tempCivicNumberId = []
            fetch('https://nsgi.novascotia.ca/nsaddress/civic/nscaf.svc/rest/json/quickCivicAddress/' + name).then(response => response.json()).then(data => setDataArr(data))
            // console.log(dataArr.civicResults?.[0]?.civicnumberid)

            for (let i = 0; i < 15; i++) {
                // console.log(dataArr.civicResults?.[i]?.streetname)
                if (dataArr.civicResults?.[i]?.streetname != undefined) {
                    // setTempArrState(dataArr.civicResults?.[i]?.community)
                    tempSt.push(dataArr.civicResults?.[i]?.civicnumber + ' ' + dataArr.civicResults?.[i]?.streetname + ' ' + dataArr.civicResults?.[i]?.streetsuffix)
                    tempStFull.push(dataArr.civicResults?.[i]?.civicnumber + ' ' + dataArr.civicResults?.[i]?.streetname + ' ' + dataArr.civicResults?.[i]?.streetsuffix + ', ' + dataArr.civicResults?.[i]?.community)

                    tempCity.push(dataArr.civicResults?.[i]?.community)
                    tempCivicNumberId.push(dataArr.civicResults?.[i]?.civicnumberid)
                }
            }
            // console.log(tempSt)

            setStreetname(tempSt)
            setStreetNameFull(tempStFull)
            // console.log(streetname[0])
            setCityName(tempCity)
            // console.log(cityName[0])
            setCivNumId(tempCivicNumberId)
            // console.log(civNumId[0])


            // setSlicedArr(dataArr.civicResults?.slice(0, 20))

            changeObjectPropertyAction('streetAddress', name);
            validateStreetAddress(name)

        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const onBlurStreetAddress = (e) => {
        try {
            SetIsFocussed(false)
            let name = e.currentTarget.value.trim()
            changeObjectPropertyAction('streetAddress', name);

            validateStreetAddress(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const onClickStreetAddress = (e) => {
        try {
            let name = e.currentTarget.value
            setDisplay(!display)

            // if (name != '') {
            //     setDisplay(!display)
            // }

        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    //triggered by onClick of dropdown div
    const setAddressInput = (index) => {
        // setStr(addr)
        let name = streetname[index]
        changeObjectPropertyAction('streetAddress', name);
        //check if needed
        // if (dataArr.civicResults?.[index]?.community != undefined) {
        //     setTempArrState(dataArr.civicResults?.[index]?.community)
        // }
        // else if (dataArr.civicResults?.[index]?.county != undefined) {
        //     setTempArrState(dataArr.civicResults?.[index]?.county)
        // }

        // if (dataArr.civicResults?.[index]?.civicnumberid != undefined) {
        //     setTempPostalArrState(dataArr.civicResults?.[index]?.civicnumberid)
        // }
        setDisplay(false)
    }





    //city 

    // const dispatch = useDispatch()
    const [isFocussed2, SetIsFocussed2] = useState(false)

    let city = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).city)
    // let cityOrCounty = tempArrState
    // city = tempArrState
    // validateCity(city)




    const setCityInput = (index) => {

        try {
            let name = cityName[index]
            changeObjectPropertyAction('city', name);
            validateCity(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }

    }



    const handleCity = (e) => {
        try {

            let name = e.currentTarget.value
            // console.log(stringCityOrCounty)
            // if (stringCityOrCounty != null) {
            //   name = stringCityOrCounty
            // }
            changeObjectPropertyAction('city', name);
            validateCity(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    // handleCity(stringCityOrCounty)


    const onBlurCity = (e) => {
        try {
            SetIsFocussed2(false)
            let name = e.currentTarget.value.trim()
            changeObjectPropertyAction('city', name);
            validateCity(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }


    //Postal Code

    let postalCode = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).postalCode)

    const [poCode, setPoCode] = useState('')

    const [apiData, setApiData] = useState([])



    const getPostalCode = async (civicNum) => {
        try {
            // console.log('api call')
            // console.log(civicNum)
            const promise = await fetch('https://nsgi.novascotia.ca/nsaddress/civic/nscaf.svc/rest/json/CivicAddress/' + civicNum)
            const json = await promise.json()
            const json2 = await json?.civicResults?.addresses[0]?.postalcode
            return json2


            // setPoCode(json2)
            // console.log(poCode)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const setPostalInput = async (index) => {

        try {
            let civicNumberId = civNumId[index]
            // console.log(civicNumberId)
            // getPostalCode(civicNumberId)
            let name = await getPostalCode(civicNumberId)

            changeObjectPropertyAction('postalCode', name);
            validatePostalCode(name.replace(' ', '').toUpperCase())
        } catch (err) {
            console.log(err)
            setIsError(true)
        }

    }

    const handlePostalCode = (e) => {
        try {
            let name = e.currentTarget.value
            changeObjectPropertyAction('postalCode', name);
            validatePostalCode(name.replace(' ', '').toUpperCase())
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const onBlurPostalCode = (e) => {
        try {
            SetIsFocussed(false)
            let name = e.currentTarget.value.replace(' ', '').toUpperCase();
            changeObjectPropertyAction('postalCode', name);
            validatePostalCode(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    //Apartment


    const apartment = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).apartment)

    const handleApartment = (e) => {
        try {
            let name = e.currentTarget.value
            changeObjectPropertyAction('apartment', name);
            validateApartment(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const onBlurApartment = (e) => {
        try {
            SetIsFocussed(false)
            let name = e.currentTarget.value.trim()
            changeObjectPropertyAction('apartment', name);
            validateApartment(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }


    return (
        <>
            <StatusInputWrapper
                isValid={streetAddressValid}
                errorMsg={streetAddressError}
                t={t}
                label={label ?? t('current_address.street_address')}
                isFocussed={isFocussed}
                id="StreetAddress"
                name="StreetAddress"
                type="text"
                customClasses={'fw-20'}
                aria-describedby="street-address"
                onClick={onClickStreetAddress}
                onChange={handleStreetAddress}
                onBlur={onBlurStreetAddress}
                onFocus={() => SetIsFocussed(true)}
                value={streetAddress}
                autoComplete="off"
                maxLength="200"
            />

            {display && (
                <div className="auto-container" >
                    {/* {streetname.map((v, i) => {
                        return <div onClick={() => {
                            setAddressInput(v, i)
                            setCityInput(i)
                            setPostalInput(i)
                        }} key={i}>
                            <span>{v}</span>
                        </div>
                    })} */}
                    {streetNameFull.map((v, i) => {
                        return <div style={{ cursor: 'pointer' }} onClick={() => {
                            setAddressInput(i)
                            setCityInput(i)
                            setPostalInput(i)
                        }} key={i}>
                            <span>{v}</span>
                        </div>
                    })}
                </div>
            )}

            <StatusInputWrapper
                isValid={apartmentValid}
                errorMsg={apartmentError}
                t={t}
                label={t('current_address.apartment')}
                customClasses={'fw-4'}
                id="Apartment" name="Apartment" type="text"
                isFocussed={isFocussed}
                aria-describedby="apartment"
                onChange={handleApartment}
                onBlur={onBlurApartment}
                onFocus={() => SetIsFocussed(true)}
                value={apartment}
                autoComplete="off"
                maxLength="20"
            />


            <StatusInputWrapper
                isValid={cityValid}
                errorMsg={cityError}
                t={t}
                label={t('current_address.city')}
                customClasses={'fw-10'}
                id="City" name="City" type="text"
                isFocussed={isFocussed2}
                aria-describedby="city"
                onChange={handleCity}
                onBlur={onBlurCity}
                onFocus={() => SetIsFocussed2(true)}
                value={city}
                autoComplete="off"
                maxLength="50"
            />

            <StatusInputWrapper
                isValid={postalCodeValid}
                errorMsg={postalCodeError}
                t={t}
                label={t('current_address.postal_code')}
                id="PostalCode" name="PostalCode" type="text"
                isFocussed={isFocussed}
                aria-describedby="postal-code"
                customClasses={'fw-6'}
                onChange={handlePostalCode}
                onBlur={onBlurPostalCode}
                onFocus={() => SetIsFocussed(true)}
                value={postalCode}
                autoComplete="off"
                maxLength="7"
            />

        </>
    )
}

export default withTranslation('common')(AddressAutofill)